import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Component } from 'react';
import RouteParamConstants from '../../utils/routeParamConstants';
import { linkLoyaltyCard } from '../../api/LoyaltyCardInterface';
import Validators from '../../components/Form/InputValidator';
import { checkIfOtpIsRequired } from './../OneTimePassword/utils';
import AppInterface from '../../api/AppInterface';
import routeParamConstants from '../../utils/routeParamConstants';
import QueryParamsProxy from '../../utils/queryParamProxy';
import Screens from '../../screens';
import ENVIRONMENT_VARIABLES from '../../utils/environmentVariables';
import { REQUEST_STATE } from '../OneTimePassword/hooks/useOTPrequestHandler';
import store from '../../state/store';
import { postOTPSendEmail } from '../../state/query/oneTimePassword';
import { ServerResponseKeys } from '../../api/Constants';
import { getText, TEXT_KEY } from '../../utils/localization';

var LinkAccountForm = /*#__PURE__*/function (_Component) {
  _inherits(LinkAccountForm, _Component);

  var _super = _createSuper(LinkAccountForm);

  function LinkAccountForm() {
    var _this;

    _classCallCheck(this, LinkAccountForm);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      error: null,
      message: null,
      success: false
    };

    _this.clearError = function () {
      _this.setState({
        error: null
      });
    };

    _this.isBodyValid = function (values) {
      return Validators.LENGTH_EQUALTO(values.year, 4) && Validators.NUMBERS_ONLY(parseInt(values.year, 10)) && Validators.NOT_EMPTY(values.month) && Validators.NOT_EMPTY(values.day) && Validators.ADULT_ONLY("".concat(values.year, "-").concat(values.month, "-").concat(values.day)) && Validators.NOT_EMPTY(values.accountNumber);
    };

    _this.isPinAccountValid = function (values) {
      return Validators.NOT_EMPTY(values.accountNumber) && Validators.NOT_EMPTY(values.pin);
    };

    _this.isPropertyValid = function (value) {
      return Validators.NOT_EMPTY(value);
    };

    _this.setPropertyId = function (userProperty, propertyId) {
      return userProperty === 1 ? propertyId : userProperty;
    };

    _this.handlePinAndAccount = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(values) {
        var accountNumber, pin;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                accountNumber = values.accountNumber, pin = values.pin;

                if (_this.isPinAccountValid({
                  accountNumber: accountNumber,
                  pin: pin
                })) {
                  _context.next = 4;
                  break;
                }

                _this.setState({
                  success: false,
                  error: getText(TEXT_KEY.FORM_INVALID_ERROR)
                });

                return _context.abrupt("return", false);

              case 4:
                _this.linkAccount({
                  cardnum: accountNumber,
                  pin: pin
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.handleLinkAccount = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(values) {
        var _this$props, userProperty, propertySelector, valuesWithZeros, hasPropertySelector, accountNumber, year, month, day, propertyId, dataObject, otpRequired, _error$data;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$props = _this.props, userProperty = _this$props.userProperty, propertySelector = _this$props.propertySelector;
                valuesWithZeros = _objectSpread({}, values);
                hasPropertySelector = ENVIRONMENT_VARIABLES.SHOW_PROPERTY_SELECTOR;
                valuesWithZeros.day = _this._addZeroPrefixToValue(valuesWithZeros.day);
                valuesWithZeros.month = _this._addZeroPrefixToValue(valuesWithZeros.month);

                if (!(!_this.isBodyValid(valuesWithZeros) || userProperty === 1 && !_this.isPropertyValid(valuesWithZeros.propertyId) && hasPropertySelector)) {
                  _context2.next = 8;
                  break;
                }

                _this.setState({
                  success: false,
                  error: getText(TEXT_KEY.AGE_UNDER_18_OR_FORM_INCOMPLETE_ERROR)
                });

                return _context2.abrupt("return", false);

              case 8:
                accountNumber = valuesWithZeros.accountNumber, year = valuesWithZeros.year, month = valuesWithZeros.month, day = valuesWithZeros.day, propertyId = valuesWithZeros.propertyId;
                dataObject = {
                  cardnum: accountNumber,
                  pin: "".concat(year, "-").concat(month, "-").concat(day)
                };
                if (userProperty && hasPropertySelector) dataObject.propertyId = _this.setPropertyId(userProperty, propertyId);
                otpRequired = checkIfOtpIsRequired(_this.setPropertyId(userProperty, propertyId), propertySelector);

                try {
                  _this.checkToLinkAccount(otpRequired, dataObject);
                } catch (error) {
                  _this.setState({
                    success: false,
                    error: error === null || error === void 0 ? void 0 : (_error$data = error.data) === null || _error$data === void 0 ? void 0 : _error$data.message
                  });
                }

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this.checkToLinkAccount = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(otpRequired, dataObject) {
        var pin, propertyId, cardnum, _QueryParamsProxy$set, otpValidationRequest, otpAuthTransaction, otpPromise, response, _error$data2;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!otpRequired) {
                  _context3.next = 19;
                  break;
                }

                pin = dataObject.pin, propertyId = dataObject.propertyId, cardnum = dataObject.cardnum;
                _context3.prev = 2;
                _context3.next = 5;
                return store.dispatch(postOTPSendEmail.initiate(_objectSpread(_objectSpread({}, propertyId && {
                  propertyId: propertyId
                }), {}, {
                  cardnum: cardnum,
                  dob: pin
                }))).unwrap();

              case 5:
                otpValidationRequest = _context3.sent;
                otpAuthTransaction = otpValidationRequest[ServerResponseKeys.CALL_RESPONSE].otpAuthTransaction;
                otpPromise = QueryParamsProxy.setQueryParamsWithModalPromise((_QueryParamsProxy$set = {}, _defineProperty(_QueryParamsProxy$set, RouteParamConstants.PARAM_MODAL, Screens.OneTimePassword), _defineProperty(_QueryParamsProxy$set, RouteParamConstants.PARAM_OTP_PROPERTY_ID, propertyId), _defineProperty(_QueryParamsProxy$set, RouteParamConstants.PARAM_OTP_CARD_NUMBER, cardnum), _defineProperty(_QueryParamsProxy$set, RouteParamConstants.PARAM_OTP_DOB, pin), _defineProperty(_QueryParamsProxy$set, RouteParamConstants.PARAM_OTP_TRANSACTION_ID, otpAuthTransaction === null || otpAuthTransaction === void 0 ? void 0 : otpAuthTransaction.transactionId), _defineProperty(_QueryParamsProxy$set, RouteParamConstants.PARAM_OTP_USER_ID, otpAuthTransaction === null || otpAuthTransaction === void 0 ? void 0 : otpAuthTransaction.userId), _QueryParamsProxy$set));
                _context3.next = 10;
                return otpPromise;

              case 10:
                response = _context3.sent;
                if ((response === null || response === void 0 ? void 0 : response.success) === REQUEST_STATE.AUTHENTICATE) _this.linkAccount(dataObject);
                _context3.next = 17;
                break;

              case 14:
                _context3.prev = 14;
                _context3.t0 = _context3["catch"](2);

                _this.setState({
                  success: false,
                  error: _context3.t0 === null || _context3.t0 === void 0 ? void 0 : (_error$data2 = _context3.t0.data) === null || _error$data2 === void 0 ? void 0 : _error$data2.message
                });

              case 17:
                _context3.next = 20;
                break;

              case 19:
                _this.linkAccount(dataObject);

              case 20:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[2, 14]]);
      }));

      return function (_x3, _x4) {
        return _ref3.apply(this, arguments);
      };
    }();

    _this.linkAccount = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dataObject) {
        var response, _response$, success, _response$$error, error, _response$$msg, message, _this$props2, setCasinoIdStatus, setCasinoId, setCurrentMemberLevel, isAccountLinked, initAppRes;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return linkLoyaltyCard(dataObject);

              case 2:
                response = _context4.sent;

                if (response[0]) {
                  _context4.next = 5;
                  break;
                }

                return _context4.abrupt("return", false);

              case 5:
                _response$ = response[0], success = _response$.success, _response$$error = _response$.error, error = _response$$error === void 0 ? '' : _response$$error, _response$$msg = _response$.msg, message = _response$$msg === void 0 ? '' : _response$$msg;

                if (success) {
                  _context4.next = 10;
                  break;
                }

                _this.setState({
                  success: success,
                  error: error
                });

                _context4.next = 26;
                break;

              case 10:
                _this.setState({
                  success: success,
                  message: message
                });

                _context4.prev = 11;
                _this$props2 = _this.props, setCasinoIdStatus = _this$props2.setCasinoIdStatus, setCasinoId = _this$props2.setCasinoId, setCurrentMemberLevel = _this$props2.setCurrentMemberLevel, isAccountLinked = _this$props2.isAccountLinked;
                _context4.next = 15;
                return AppInterface.initApp();

              case 15:
                initAppRes = _context4.sent;
                setCasinoIdStatus(initAppRes.CASINO_ID_STATUS);
                setCasinoId(initAppRes.CASINO_ID);
                setCurrentMemberLevel(initAppRes.CURRENT_MEMBER_LEVEL);
                isAccountLinked('yes');

                _this.navigateToScreen(undefined);

                _context4.next = 26;
                break;

              case 23:
                _context4.prev = 23;
                _context4.t0 = _context4["catch"](11);
                console.log(_context4.t0);

              case 26:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[11, 23]]);
      }));

      return function (_x5) {
        return _ref4.apply(this, arguments);
      };
    }();

    _this.navigateToScreen = function (screen) {
      return QueryParamsProxy.setQueryParams(_defineProperty({}, routeParamConstants.PARAM_MODAL, screen));
    };

    _this.handleRegisterRewardCard = function () {
      return _this.navigateToScreen(Screens.RegisterRewardCard);
    };

    _this._addZeroPrefixToValue = function (value) {
      var newValue = value;

      if (parseInt(newValue, 10) < 10) {
        newValue = "0".concat(parseInt(newValue, 10));
      }

      return newValue;
    };

    _this.findSelectedPropertyObject = function (selectedPropertyId) {
      return _this.props.propertySelector.find(function (property) {
        return property.propertyId === Number(selectedPropertyId);
      });
    };

    return _this;
  }

  _createClass(LinkAccountForm, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          linkedLoyaltyCardBonus = _this$props3.linkedLoyaltyCardBonus,
          userProperty = _this$props3.userProperty,
          propertySelector = _this$props3.propertySelector,
          copys = _this$props3.copys,
          enableOrderCard = _this$props3.enableOrderCard;
      var _this$state = this.state,
          success = _this$state.success,
          error = _this$state.error,
          message = _this$state.message;
      return this.props.render({
        handleLinkAccount: this.handleLinkAccount,
        handlePinAndAccount: this.handlePinAndAccount,
        handleRegisterRewardCard: this.handleRegisterRewardCard,
        clearError: this.clearError,
        linkedLoyaltyCardBonus: linkedLoyaltyCardBonus,
        termsAndConditionsUrl: this.props.assetsUrls ? this.props.assetsUrls.termsAndConditions : '',
        success: success,
        error: error,
        message: message,
        userProperty: userProperty,
        propertySelector: propertySelector,
        setPropertyId: this.setPropertyId,
        copys: copys,
        enableOrderCard: enableOrderCard,
        findSelectedPropertyObject: this.findSelectedPropertyObject
      });
    }
  }]);

  return LinkAccountForm;
}(Component);

export { LinkAccountForm as default };